import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
	container: {
		flex: 1
	},
	text: { fontSize: 42 },
	matchPlayer: { fontWeight: 'bold' },
	matchTeam: { fontStyle: 'italic' },
	matchPoints: { textDecorationLine: 'underline', fontWeight: 'bold' },
	matchFalta: { color: '#e60000' },
	matchPointsPhrase: { color: '#b38f00' },
	matchScoreboard: {
		fontWeight: 'bold',
		fontSize: 16,
		textAlign: 'center'
	},
	matchLesion: { color: '#ff6600' },
	matchBludger: { color: '#006666'},
	matchEnd: {color: 'green', textAlign: 'center'},
	textSubstitute: {color: '#4d004d'},
	textCenter: {textAlign: 'center'},
	tr: {textAlign: 'right'},
	tl: {textAlign: 'left'}
});

export default styles;